import * as svg from "../../../assets/gears-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const GearIcon = iconBuilder(svg, "GearIcon", "0 0 20 20");
